var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"pt-3 pb-3",attrs:{"items":_vm.items,"dense":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }